(() => {
  if (window.cbCaratGuideInitialized) return;

  window.cbCaratGuideInitialized = true;

  let lastTrigger = null;

  const caratGuideData = {
    round: {
      title: 'Round Brilliant Diamond Weight',
      rows: [
        ['4 mm.', '0.25 ct.'],
        ['5 mm.', '0.50 ct.'],
        ['6 mm.', '0.80 ct.'],
        ['6.5 mm.', '1.00 ct.'],
        ['7.5 mm.', '1.50 ct.'],
        ['8 mm.', '2.00 ct.'],
        ['9 mm.', '3.00 ct.'],
        ['11 mm.', '5.00 ct.']
      ]
    },

    heart: {
      title: 'Heart Diamond Weight',
      rows: [
        ['4 mm.', '0.25 ct.'],
        ['5 mm.', '0.50 ct.'],
        ['6 mm.', '0.75 ct.'],
        ['6.5 mm.', '1.00 ct.'],
        ['7.5 mm.', '1.50 ct.'],
        ['8 mm.', '2.00 ct.'],
        ['9 mm.', '3.00 ct.'],
        ['11.5 mm.', '5.00 ct.']
      ]
    },

    emerald: {
      title: 'Emerald Diamond Weight',
      rows: [
        ['6x4 mm.', '0.50 ct.'],
        ['6.5x4.5 mm.', '0.75 ct.'],
        ['7x5 mm.', '1.00 ct.'],
        ['7.3x5.3 mm.', '1.25 ct.'],
        ['7.5x5.5 mm.', '1.50 ct.'],
        ['8.5x6.5 mm.', '2.00 ct.'],
        ['9.3x7.5 mm.', '3.00 ct.'],
        ['11x9 mm.', '5.00 ct.']
      ]
    },

    cushion: {
      title: 'Cushion Diamond Weight',
      rows: [
        ['4.9 mm.', '0.50 ct.'],
        ['5.25 mm.', '0.75 ct.'],
        ['5.5 mm.', '1.00 ct.'],
        ['6 mm.', '1.25 ct.'],
        ['6.5 mm.', '1.50 ct.'],
        ['7 mm.', '2.00 ct.'],
        ['8 mm.', '3.00 ct.'],
        ['9.5 mm.', '5.00 ct.']
      ]
    },

    pear: {
      title: 'Pear Diamond Weight',
      rows: [
        ['6x4 mm.', '0.50 ct.'],
        ['7x5 mm.', '0.75 ct.'],
        ['7.7x5.7 mm.', '1.00 ct.'],
        ['8x6 mm.', '1.25 ct.'],
        ['8.5x6.5 mm.', '1.50 ct.'],
        ['9x7 mm.', '2.00 ct.'],
        ['12x8 mm.', '3.00 ct.'],
        ['15x9 mm.', '5.00 ct.']
      ]
    },

    princess: {
      title: 'Princess Diamond Weight',
      rows: [
        ['4.5 mm.', '0.50 ct.'],
        ['5 mm.', '0.75 ct.'],
        ['5.5 mm.', '1.00 ct.'],
        ['6 mm.', '1.25 ct.'],
        ['6.5 mm.', '1.50 ct.'],
        ['7 mm.', '2.00 ct.'],
        ['8 mm.', '3.00 ct.'],
        ['9.5 mm.', '5.00 ct.']
      ]
    },

    oval: {
      title: 'Oval Diamond Weight',
      rows: [
        ['6x4 mm.', '0.50 ct.'],
        ['7x5 mm.', '0.75 ct.'],
        ['7.7x5.7 mm.', '1.00 ct.'],
        ['8x6 mm.', '1.25 ct.'],
        ['8.5x6.5 mm.', '1.50 ct.'],
        ['9x7 mm.', '2.00 ct.'],
        ['12x8 mm.', '3.00 ct.'],
        ['12x10 mm.', '5.00 ct.']
      ]
    },

    radiant: {
      title: 'Radiant Diamond Weight',
      rows: [
        ['6x4 mm.', '0.50 ct.'],
        ['6.5x4.5 mm.', '0.75 ct.'],
        ['7x5 mm.', '1.00 ct.'],
        ['7.3x5.5 mm.', '1.25 ct.'],
        ['7.5x5.8 mm.', '1.50 ct.'],
        ['8.2x6.2 mm.', '2.00 ct.'],
        ['9.5x7.5 mm.', '3.00 ct.'],
        ['11x9 mm.', '5.00 ct.']
      ]
    },

    marquise: {
      title: 'Marquise Diamond Weight',
      rows: [
        ['8x4 mm.', '0.50 ct.'],
        ['9x4.5 mm.', '0.75 ct.'],
        ['10x5 mm.', '1.00 ct.'],
        ['11x5.5 mm.', '1.25 ct.'],
        ['12x6 mm.', '1.50 ct.'],
        ['13x6.5 mm.', '2.00 ct.'],
        ['15x7 mm.', '3.00 ct.'],
        ['17x8.5 mm.', '5.00 ct.']
      ]
    },

    trillion: {
      title: 'Trillion Diamond Weight',
      rows: [
        ['4 mm.', '0.20 ct.'],
        ['5 mm.', '0.35 ct.'],
        ['6 mm.', '0.50 ct.'],
        ['7 mm.', '0.75 ct.'],
        ['8 mm.', '1.00 ct.'],
        ['9 mm.', '1.50 ct.']
      ]
    }
  };

  function findDrawer(trigger) {
    const productInfo = trigger?.closest(
      'product-info'
    );

    return (
      productInfo?.querySelector(
        '[data-cb-guide-drawer]'
      ) ||
      document.querySelector(
        '[data-cb-guide-drawer]'
      )
    );
  }

  function renderTables(drawer) {
    if (
      !drawer ||
      drawer.dataset.caratTablesRendered ===
        'true'
    ) {
      return;
    }

    Object.entries(caratGuideData).forEach(
      ([shape, data]) => {
        const panel = drawer.querySelector(
          `[data-shape-panel][data-shape="${shape}"]`
        );

        const tbody = drawer.querySelector(
          `[data-carat-table-body="${shape}"]`
        );

        if (!panel || !tbody) return;

        const title = panel.querySelector(
          '[data-carat-table-title]'
        );

        if (title) {
          title.textContent = data.title;
        }

        tbody.innerHTML = data.rows
          .map(
            ([mm, carat]) => `
              <tr>
                <td>
                  <span class="cb-carat-simple-table__mm">
                    ${mm}
                  </span>
                </td>

                <td>
                  <span class="cb-carat-simple-table__carat">
                    ${carat}
                  </span>
                </td>
              </tr>
            `
          )
          .join('');
      }
    );

    drawer.dataset.caratTablesRendered =
      'true';
  }

  function setActiveShape(drawer, shape) {
    if (!drawer) return;

    drawer
      .querySelectorAll('[data-shape-trigger]')
      .forEach((button) => {
        const isActive =
          button.dataset.shape === shape;

        button.classList.toggle(
          'is-active',
          isActive
        );

        button.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });

    drawer
      .querySelectorAll('[data-shape-panel]')
      .forEach((panel) => {
        panel.classList.toggle(
          'is-active',
          panel.dataset.shape === shape
        );
      });
  }

  function lockPage() {
    document.documentElement.classList.add(
      'cb-guide-lock'
    );

    document.body.classList.add(
      'cb-guide-lock'
    );
  }

  function unlockPage() {
    document.documentElement.classList.remove(
      'cb-guide-lock'
    );

    document.body.classList.remove(
      'cb-guide-lock'
    );
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;

    lastTrigger = trigger || null;

    renderTables(drawer);
    setActiveShape(drawer, 'round');

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');

    lockPage();

    window.requestAnimationFrame(() => {
      drawer
        .querySelector('[data-cb-guide-close]')
        ?.focus();
    });
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');

    unlockPage();

    if (
      lastTrigger &&
      document.contains(lastTrigger)
    ) {
      lastTrigger.focus();
    }

    lastTrigger = null;
  }

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest(
      '[data-cb-carat-guide-open]'
    );

    if (openTrigger) {
      event.preventDefault();

      openDrawer(
        findDrawer(openTrigger),
        openTrigger
      );

      return;
    }

    const shapeTrigger = event.target.closest(
      '[data-shape-trigger]'
    );

    if (shapeTrigger) {
      const drawer = shapeTrigger.closest(
        '[data-cb-guide-drawer]'
      );

      setActiveShape(
        drawer,
        shapeTrigger.dataset.shape
      );

      return;
    }

    const closeTrigger = event.target.closest(
      '[data-cb-guide-close]'
    );

    if (closeTrigger) {
      event.preventDefault();

      closeDrawer(
        closeTrigger.closest(
          '[data-cb-guide-drawer]'
        )
      );
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const drawer = document.querySelector(
      '[data-cb-guide-drawer].is-open'
    );

    if (drawer) {
      closeDrawer(drawer);
    }
  });
})();